import { cn } from '@/lib/utils';

interface UsdcIconProps extends React.HTMLAttributes<HTMLImageElement> {
  className?: string;
}

export const UsdcIcon = ({ className, ...props }: UsdcIconProps) => {
  return (
    <img
      src="/icons/usdc.svg"
      alt="usdc"
      className={cn('size-[16px]', className)}
      {...props}
    />
  );
};
